import React from 'react';
import { connect } from 'react-redux';

const CHUNK_RELOAD_KEY = 'chunk-error-reload-attempted';

const isChunkLoadError = (error) =>
    error &&
    (error.name === 'ChunkLoadError' ||
        /Loading chunk [\d]+ failed/i.test(error.message || '') ||
        /Loading CSS chunk [\d]+ failed/i.test(error.message || ''));

class errorBoundary extends React.Component {

    constructor() {
        super();
        this.state = {
            hasError: false
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.log(error);

        // A stale chunk from a previous deploy: reload once to pick up the
        // fresh index.html + new chunk hashes. Guarded so we never loop.
        if (isChunkLoadError(error)) {
            const alreadyReloaded =
                window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true';
            if (!alreadyReloaded) {
                window.sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
                window.location.reload();
                return;
            }
        }

        this.props.reset();
    }

    render() {

        if (this.state.hasError) {
            return <div>Some Thing Went Wrong</div>
        }

        return this.props.children
    }
}
const mapDispatchToProps = dispatch => ({
    reset: () => dispatch({type:'RESET'})
})

export default connect(null,mapDispatchToProps)(errorBoundary);
